import { InjectionFeature } from '@/common/reward/types';

export const Options = {
    features: [
        { value: InjectionFeature.ArenaTicket, label: 'ArenaTicket' },
        { value: InjectionFeature.CreditTicket, label: 'CreditTicket' },
        { value: InjectionFeature.ScratchTicket, label: 'ScratchTicket' },
        { value: InjectionFeature.AddChips, label: 'AddChips' }
    ],

    arenas: [
        { label: 'ArenaStandard', value: 1, background: 'success' },
        { label: 'ArenaPremium', value: 2, background: 'info' }
    ],
    scratchTickets: [
        { label: 'ScratchSilver', value: 1, background: 'success' },
        { label: 'ScratchGolden', value: 2, background: 'info' }
    ],
    statusList: [
        { value: 0, label: 'None', background: 'secondary' },
        { value: 1, label: 'Enabled', background: 'info' },
        { value: 2, label: 'Started', background: 'success' },
        { value: 3, label: 'Ended', background: 'warning' },
        { value: 4, label: 'Disabled', background: 'warning' }
    ]
};
